<template>
  <div>
    <section>
      <h3>Definitions</h3>
      <ol>
        <li>
          <strong>"Services"</strong> - – Refers to the GP, ANP, physiotherapy
          services, and will depend on the plan or package chosen by your
          employer, insurer, or organisation.
        </li>
        <li>
          <strong>"User" or "You"</strong> - Refers to any individual accessing
          or using the Services
        </li>
        <li>
          <strong>"Platform"</strong> - Refers to the Spectrum.Life app or web
          portal where Services are accessed.
        </li>
        <li>
          <strong>"Clinician"</strong> - Refers to qualified professionals
          providing the Services, such as psychologists, dietitians, advanced
          nurse practitioners, and mental health coaches.
        </li>
        <li>
          <strong>"Spectrum.Life"</strong> - SPECTRUM WELLNESS UK LTD T/A
          Spectrum.Life, a company incorporated in England and Wales with
          registered number 11815511, registered address: Habib House, 9
          Stevenson Square, Manchester M1 1DB, UK.
        </li>
      </ol>
    </section>

    <section>
      <h3>Introduction</h3>
      <p>
        These Terms of Use apply between You, the User of the Spectrum.Life
        service including online Wellbeing and Clinical Consultations (‘the
        Service’), and Spectrum Wellness UK Limited T/A Spectrum.Life
        (‘Spectrum.Life’), the provider of the Service.
      </p>
      <p>
        By using Spectrum.Life, You agree to be bound by these Terms. If You do
        not agree, please stop using the Service.
      </p>
      <p>These Terms include important information including:</p>
      <ul>
        <li>The Health Disclaimer (Section 4)</li>
        <li>The scope and limitations of each service type (Section 5)</li>
        <li>
          The availability and limitations of digital delivery (Section 9)
        </li>
        <li>The limitation of liability (Section 11)</li>
      </ul>
      <p>
        By accepting these Terms of Use and using the Service, You agree to
        comply with and be bound by them. If You do not agree, You should not
        access or use the Service.
      </p>
    </section>

    <section>
      <h3>Intellectual property and acceptable use</h3>
      <ul>
        <li>
          All Content included in the Service is the property of Spectrum.Life,
          our affiliates or other relevant third parties. In these Terms of Use,
          Content means any text, graphics, images, audio, video, software, data
          compilations, page layout, underlying code and software and any other
          form of information capable of being stored in a computer that appears
          on or forms part of this Service. By continuing to use the Service You
          acknowledge that such Content is protected by copyright, trademarks,
          database rights and other intellectual property rights. Nothing on
          this site shall be construed as granting, by implication, estoppel, or
          otherwise, any license or right to use any trademark, logo or service
          mark displayed on the site without the Spectrum.Life’s prior written
          permission.
        </li>
        <li>
          You may, for your own personal, non-commercial use only, do the
          following: retrieve, display and view the Content via Spectrum.Life.
        </li>
        <li>
          You must not otherwise reproduce, modify, copy, distribute or use for
          commercial purposes any Content without the written permission of
          Spectrum.Life.
        </li>
      </ul>
    </section>

    <section>
      <h3>Prohibited use</h3>
      <p>You may not use the Service for any of the following purposes:</p>
      <ul>
        <li>
          In any way which causes, or may cause, damage to the Service or
          interferes with any other person's use or enjoyment of the Service
        </li>
        <li>
          In any way which is harmful, unlawful, illegal, abusive, harassing,
          threatening or otherwise objectionable or in breach of any applicable
          law, regulation, governmental order
        </li>
        <li>
          For making, transmitting or storing electronic copies of Content
          protected by copyright without the permission of the Spectrum.Life.
        </li>
      </ul>
    </section>

    <section>
      <h3>Services, Consultation Scope and exclusions</h3>
      <ul>
        <li>
          Services are currently offered to UK residents or UK territory
          residents.
        </li>
        <li>
          Services are delivered in accordance with regulatory and clinical
          standards follows; as ISO90001, HCPC, BACP, EAPA, CQC, and NICE
          guidelines.
        </li>
        <li>
          A safeguarding board is maintained to ensure the safety and wellbeing
          of Users, and practitioners are trained in safeguarding protocols.
        </li>
        <li>
          Our services are not substitutes for emergency medical care. For
          emergencies, contact your local emergency services (e.g., 111/999) or
          visit the nearest hospital.
        </li>
        <li>
          The scope and exclusion of each Service is Outlined below:

          <p>
            Spectrum.Life reserves the right to decline access to services if,
            during the booking process or subsequent consultations, it is
            determined that the user does not meet the Service's clinical or
            eligibility criteria or falls within the outlined exclusion
            criteria.
          </p>
          <p>
            This decision is made by Spectrum.Life to ensure the safety,
            effectiveness, and appropriateness of the Service for the User.
          </p>
          <p>
            Examples of situations where access may be declined include, but are
            not limited to:
          </p>
          <ul>
            <li>The User's needs require specialised or emergency care.</li>
            <li>
              The User presents with conditions or circumstances explicitly
              listed in the exclusion criteria for the Service.
            </li>
            <li>
              The User is unable to engage meaningfully with the Service due to
              factors such as acute distress, unstable physical or mental
              health, or other barriers to participation.
            </li>
          </ul>
          <p>
            In such cases, Spectrum.Life will make every effort to guide the
            User towards appropriate alternative services or resources and
            provide signposting to relevant support where applicable.
          </p>

          <ol>
            <li>
              GP ANP and physiotherapy
              <p>
                Delivered remotely by qualified General Practitioners, Advanced
                Nurse Practitioners (ANPs) and HCPC-registered Physiotherapists.
              </p>
              <p>
                Suitable for general health concerns, minor illness,
                musculoskeletal issues, and wellbeing advice.
              </p>
              <p>Excluded:</p>
              <p>
                The service is not a replacement for any regular health
                service(s) you are normally registered with, e.g., a General
                Practice. You may still need to see a healthcare professional
                face to face. You may also be advised to contact the emergency
                services if the clinician feels it is necessary.
              </p>
              <p>
                We will not clinically triage any presenting symptoms or
                conditions until the consultation with a health professional.
                Therefore, please be aware that any information disclosed to us
                in advance of a consultation, either electronically or by
                telephone is for information purposes only and will not be dealt
                with in advance of the consultation.
              </p>
              <p>
                You must not use this service for emergencies or urgent
                conditions, such as (but not limited to) those listed below, as
                this may delay necessary treatment.
              </p>
              <p>
                If you believe that you are in an emergency or life-threatening
                situation you should contact your local Emergency Services
                immediately by dialling 999 or 112, especially if you, or
                someone:
              </p>
              <ul>
                <li>has severe difficulty or are not breathing.</li>
                <li>is having a heart attack or stroke.</li>
                <li>has severe chest pain.</li>
                <li>has severe abdominal pain.</li>
                <li>has severe bleeding.</li>
                <li>has lost consciousness.</li>
                <li>
                  is in an acute confused state and/or is having fits which
                  aren’t stopping.
                </li>
                <li>is in suicidal distress.</li>
                <li>is experiencing an acute mental health crisis.</li>
              </ul>
            </li>
          </ol>
        </li>
      </ul>
    </section>

    <section>
      <h3>Users Responsibilities</h3>
      <p>
        Users must provide Spectrum.Life accurate and complete personal and
        medical information to ensure appropriate and effective service
        delivery. Users are expected to follow the recommendations provided by
        the assigned clinician or coach. Failure to do so may impact the
        clinical outcome or the value derived from the Service
      </p>
      <p>
        Users are responsible for managing appointment schedules and notifying
        Spectrum.Life promptly in case of cancellations or rescheduling needs.
      </p>
      <p>
        Parent (s) or guardian (s) will be responsible for providing supervision
        of children and young people engaging with our service and remain within
        the same environment to ensure safety; they will also be required to
        attend sessions that they have been requested to attend.
      </p>
      <p>
        Users are expected to engage with Clinicians respectfully and
        professionally. The following behaviours will not be tolerated:
      </p>
      <ul>
        <li>
          Abusive, aggressive, or threatening language or behaviour, whether
          verbal, written, or otherwise.
        </li>
        <li>
          Discrimination or harassment on the basis of race, gender, sexual
          orientation, religion, disability, or any other protected
          characteristic.
        </li>
        <li>
          Persistent non-compliance with recommendations or service guidelines
          that disrupt service delivery.
        </li>
      </ul>
      <div class="consq-heading">
        <div class="consq-title">Consequences of Unacceptable Behaviour</div>
        <div class="consq-sub">
          Spectrum.Life and Spectrum.Life reserve the right to:
        </div>
      </div>
      <ul>
        <li>
          Immediately terminate or suspend services if abusive or unacceptable
          behaviour is exhibited toward clinicians, administrative staff, or
          support teams.
        </li>
        <li>Refuse further appointments</li>
        <li>
          Report serious incidents to appropriate authorities or regulatory
          bodies if required by law.
        </li>
      </ul>
    </section>

    <section>
      <h3>Other Third-Party Links and Services</h3>
      <p>
        The platform may integrate with third-party services, such as payment
        gateways or hosting other service providers. While Spectrum.Life strive
        to ensure a seamless experience, Spectrum/Life are not responsible for
        issues arising from these external systems. Users are advised to review
        and adhere to the terms and conditions, privacy policies, and any other
        applicable policies of third-party services before using them.
      </p>

      <p>
        Links to external websites that may be provided are for informational
        purposes only and do not constitute endorsements. Spectrum.Life do not
        control or assume responsibility for the content, policies, or practices
        of third-party websites. Users should review the terms of use and
        policies of any external sites they choose to access.
      </p>
    </section>

    <section>
      <h3>Privacy and Data Protection</h3>
      <p>
        All personal and clinical data is processed in accordance with the UK
        General Data Protection Regulation (UK GDPR). For children aged 6 to 16,
        data is processed under:
      </p>
      <ul>
        <li>
          Article 6(1)(a): Consent of the parent or legal guardian.
        </li>
        <li>
          Article 9(2)(h): Provision of health or social care services
        </li>
      </ul>
      <p>
        Data is retained securely for up to seven years, as required by law. In
        relation to children and young people is to retain until the individual
        reaches 25 years of age or for 7 years following discharge, whichever is
        longer.
      </p>
      <p>
        All data is encrypted in transit and at rest. Access to clinical data is
        role-based and logged. Our systems follow ISO 27001 standards. Clinical
        records are stored securely and access is restricted to authorised
        clinicians and administrators
      </p>
      <p>Please view our Privacy Policy for more information.</p>
      <p>
        For privacy related concerns, please email:
        <a href="mailto:gdprspectrumlife@spectrum.life"
          >gdprspectrumlife@spectrum.life</a
        >.
      </p>
      <p>
        Only the minimum amount of personal data necessary to deliver the
        service is collected. This includes identification, contact details,
        demographic data, presenting issues, and clinical notes. Data is used
        exclusively for service provision, suitability assessment, safeguarding,
        and outcome reporting in accordance with UK GDPR.
      </p>
    </section>

    <section>
      <h3>Confidentiality</h3>
      <p>
        As a general rule, your practitioner will keep the information You share
        with them in your consultations private.
      </p>
      <p>
        There are, however, exceptions to this rule that are important for You
        to understand before You share your personal information in a
        consultation. These exceptions are as follows:
      </p>
      <ul>
        <li>
          If You are doing things that could cause serious harm to You or
          someone else, even if You do not intend to harm yourself or another
          person. This may include anything which the law states is an offence.
        </li>
        <li>
          If You tell us You plan to cause serious harm to yourself or plan to
          end your life. In this situation, we must make sure that You are
          protected.
        </li>
        <li>
          If You tell us that You plan to cause serious harm to someone else who
          can be identified.
        </li>
        <li>
          If You tell us that a person under 18 years old is being abused –
          physically, sexually or emotionally – or that they have been abused in
          the past.
        </li>
        <li>If a legal order is issued overruling confidentiality.</li>
        <li>
          Any reason where required by law or safeguarding obligations under the
          Children Act 1989 (England).
        </li>
      </ul>
      <p>
        It is important to understand that in the situations mentioned above,
        this would be openly discussed with You where possible if any of the
        above situations do in fact arise.
      </p>
    </section>

    <section>
      <h3>Availability of the Service and Disclaimers</h3>
      <ul>
        <li>
          Spectrum.Life are committed to providing high quality and engaging
          content and consultations to Users.
        </li>
        <li>
          Any online facilities, tools, services or information that
          Spectrum.Life makes available through Service is provided "as is" and
          on an "as available" basis.
        </li>
        <li>
          Spectrum.Life accepts no liability for any disruption or
          non-availability of the Service.
        </li>
        <li>
          The Service may be subject to change from time to time and this may
          include the addition, alteration, replacement, suspension or
          withdrawal of Content. Such changes shall not materially affect the
          Services available to You and may not be notified to You.
        </li>
      </ul>
    </section>

    <section>
      <h3>Limitation of Liability</h3>
      <ul>
        <li>
          Nothing in these Terms of Use will:
          <ul>
            <li>
              Limit or exclude our or your liability for death or personal
              injury resulting from our or your negligence, as applicable;
            </li>
            <li>
              Limit or exclude our or your liability for fraud or fraudulent
              misrepresentation; or
            </li>
            <li>
              Limit or exclude any of our or your liabilities in any way that is
              not permitted under applicable law.
            </li>
            <li>
              We will not be liable to you in respect of any losses arising out
              of events beyond our reasonable control.
            </li>
            <li>
              Users agree to indemnify Spectrum.Life against liabilities arising
              from misuse of the services or violation of these terms.
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <section>
      <h3>Complaints & Feedback</h3>
      <ul>
        <li>
          Clinical and wellbeing complaints will be managed by Spectrum.Life
          Submit details via email to
          <a href="mailto:eap@spectrum.life">eap@spectrum.life</a>
        </li>
        <li>
          All complaints will be acknowledged within two (2) working days and
          resolved within ten (10) working days (from date of consent received)
          unless further investigation and, or consent is required.
        </li>
      </ul>
    </section>

    <section>
      <h3>General</h3>
      <ul>
        <li>
          You may not transfer any of your rights under these Terms of Use to
          any other person. We may transfer our rights under these Terms of Use
          where we reasonably believe your rights will not be affected.
        </li>
        <li>
          These Terms of Use, together with the
          <a href="https://www.spectrum.life/privacy">Privacy Policy</a> for
          Spectrum.Life Service, contain the whole agreement between the parties
          relating to its subject matter and supersede all prior discussions,
          arrangements or agreements that might have taken place in relation to
          the Terms of Use. To view the Spectrum.Life Privacy Policy, please
          follow the link in Spectrum.life.
        </li>
        <li>
          The Contracts (Rights of Third Parties) Act 1999 shall not apply to
          these Terms of Use and no third party will have any right to enforce
          or rely on any provision of these Terms of Use.
        </li>
        <li>
          If any court or competent authority finds that any provision of these
          Terms of Use (or part of any provision) is invalid, illegal or
          unenforceable, that provision or part-provision will, to the extent
          required, be deemed to be deleted, and the validity and enforceability
          of the other provisions of these Terms of Use will not be affected.
        </li>
        <li>
          Unless otherwise agreed, no delay, act or omission by a party in
          exercising any right or remedy will be deemed a waiver of that, or any
          other, right or remedy.
        </li>
        <li>
          This Agreement shall be governed by and interpreted according to the
          law of England and Wales and all disputes arising under the Agreement
          (including non-contractual disputes or claims) shall be subject to the
          exclusive jurisdiction of the English and Welsh courts.
        </li>
      </ul>
    </section>

    <section>
      <p>
        SPECTRUM WELLNESS UK LTD T/A Spectrum.Life - Company and contact details
      </p>
      <ul>
        <li>
          SPECTRUM WELLNESS UK LTD T/A Spectrum.Life is a company incorporated
          in England and Wales with registered number 11815511 whose registered
          address is Habib House, 9 Stevenson Square, Manchester M1 1DB, UK
        </li>
        <li>
          You can contact SPECTRUM WELLNESS UK LTD T/A Spectrum.Life by email on
          <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { getSupportEmail } from "@/utils/supportEmail/supportEmail";

export default {
  name: "TCsSparkContent",
  computed: {
    supportEmail() {
      return getSupportEmail();
    },
  },
};
</script>

<style scoped>
.consq-heading .consq-title {
  margin: 0;
}

.consq-heading .consq-sub {
  margin: 0.25rem 0 0 1rem;
}
</style>
